export const debugTypes = {
    CACHE_WIDGET: 'CACHE_WIDGET',
    CLEAR_WIDGET_CACHE: 'CLEAR_WIDGET_CACHE',
    TOGGLE_CACHING: 'TOGGLE_CACHING',
    TOGGLE_LOG_STATS: 'TOGGLE_LOG_STATS',
    TOGGLE_WIDGET_DIAGNOSTICS: 'TOGGLE_WIDGET_DIAGNOSTICS',
}
